import localstorage from '@/lib/localstorage'
import api from '@/lib/api'

// Reads the org-role privileges list (used to hide specific menu items) from
// localStorage. If it isn't there yet (e.g. right after the OTP/TOTP/email
// magic-link login flow, which doesn't populate it like the direct login
// response does), falls back to fetching it from /user/profile and caches
// the result back into localStorage.
export async function getPrivilagesWithFallback() {
  const stored = localstorage.getItem('privilages')
  if (stored && stored !== 'undefined') {
    try {
      const parsed = JSON.parse(stored)
      if (Array.isArray(parsed)) {
        return parsed
      }
    } catch (e) {
      // fall through to fetch
    }
  }

  try {
    const res = await api.GET('user/profile')
    const privilages = (res.data && res.data.organization_role && res.data.organization_role.privilages) || []
    localstorage.setItem('privilages', JSON.stringify(privilages))
    return privilages
  } catch (e) {
    return []
  }
}

export default getPrivilagesWithFallback
